/*
  IVERAYA — reseñas: "Mostrar más" de 4 en 4 y "Mostrar menos".
  Estado único: visibleCount. Tras cada cambio se recorre TODA la lista y se
  fija la visibilidad de cada tarjeta según su índice (hidden + clase).
  Inicialización idempotente (data-iveraya-reviews-ready) y compatible con el
  editor de Shopify (shopify:section:load).
*/
(function () {
  function initSection(section) {
    if (!section || section.dataset.iverayaReviewsReady === 'true') return;
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-iveraya-review]'));
    var button = section.querySelector('[data-iveraya-show-more]');
    var label = button ? button.querySelector('[data-iveraya-show-more-label]') : null;
    var top = section.querySelector('[data-iveraya-reviews-top]') || section;
    var step = parseInt(section.getAttribute('data-iveraya-step'), 10) || 4;
    var total = cards.length;
    var visibleCount = Math.min(step, total);
    section.dataset.iverayaReviewsReady = 'true';

    function render(animateFrom) {
      cards.forEach(function (card, index) {
        var visible = index < visibleCount;
        if (visible) {
          card.hidden = false;
          card.classList.remove('iveraya-review-hidden');
          if (animateFrom !== null && index >= animateFrom) {
            card.classList.add('is-revealing');
            window.setTimeout(function () { card.classList.remove('is-revealing'); }, 500);
          }
        } else {
          card.hidden = true;
          card.classList.add('iveraya-review-hidden');
          card.classList.remove('is-revealing');
        }
      });
      if (!button) return;
      if (total <= step) {
        button.hidden = true;
        return;
      }
      var allShown = visibleCount >= total;
      if (label) label.textContent = allShown ? button.dataset.showLessText : button.dataset.showMoreText;
      button.setAttribute('aria-expanded', String(allShown));
    }

    if (button) {
      button.addEventListener('click', function () {
        if (visibleCount >= total) {
          visibleCount = Math.min(step, total);
          render(null);
          top.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          var from = visibleCount;
          visibleCount = Math.min(visibleCount + step, total);
          render(from);
        }
      });
    }

    render(null);
  }

  function initAll() {
    document.querySelectorAll('[data-iveraya-reviews]').forEach(initSection);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Editor de Shopify: la sección se vuelve a renderizar → reinicializar sin duplicar listeners
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector ? event.target.querySelector('[data-iveraya-reviews]') : null;
    if (section) initSection(section);
  });
})();
